import { render, staticRenderFns } from "./EmployeesTab.vue?vue&type=template&id=061f8f7e&scoped=true"
import script from "./EmployeesTab.vue?vue&type=script&lang=js"
export * from "./EmployeesTab.vue?vue&type=script&lang=js"
import style0 from "./EmployeesTab.vue?vue&type=style&index=0&id=061f8f7e&prod&scoped=true&lang=scss"
import style1 from "./EmployeesTab.vue?vue&type=style&index=1&id=061f8f7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061f8f7e",
  null
  
)

export default component.exports